import { bookingStatusType } from 'shared-types/bookingStatusTypes';
import moment from 'moment';
import LocalStorageService from 'external-services/local-storage-service/localStorage.service';
import { NgLocalStorageKey } from 'shared-types';

const NS = 'SpamProtectionService';

class SpamProtectionService {
  private isTurnOff: boolean = false;
  public setIsTurnOff(isTurnOff: boolean): void {
    this.isTurnOff = isTurnOff;
  }
  public isSpamBooking(booking: { _id: string }): boolean {
    if (this.isTurnOff) {
      return false;
    }
    let isFlag;
    const lastBooking = this.getLastBooking();
    if (this.isOneSec()) {
      if (lastBooking) {
        if (this.compareBooking(lastBooking, booking)) {
          isFlag = true;
        } else {
          isFlag = false;
        }
      } else {
        isFlag = false;
      }
    } else isFlag = false;

    this.setLastBookingTime();
    this.setLastBooking(booking);
    return isFlag;
  }

  private compareBooking(lastBooking: any, compareBooking: any): boolean {
    if (lastBooking.bookingType !== compareBooking.bookingType) return false;
    if (lastBooking.type !== compareBooking.type) return false;
    if (lastBooking.duration !== compareBooking.duration) return false;
    if (lastBooking.serviceId !== compareBooking.serviceId) return false;
    if (lastBooking.bookingType !== compareBooking.bookingType) return false;
    if (lastBooking.serviceName !== compareBooking.serviceName) return false;
    if (lastBooking.serviceType !== compareBooking.serviceType) return false;
    if (lastBooking.people !== compareBooking.people) return false;

    if (lastBooking.status.code !== compareBooking.status.code) return false;
    if (lastBooking.status.name !== compareBooking.status.name) return false;
    if (lastBooking.status.statusType !== compareBooking.status.statusType) return false;
    if (lastBooking.status.enabled !== compareBooking.status.enabled) return false;
    if (lastBooking.status.statusEditable !== compareBooking.status.statusEditable) return false;

    if (lastBooking.tables.length !== compareBooking.tables.length) return false;

    if (lastBooking.checkCustomer.firstName !== compareBooking.checkCustomer.firstName)
      return false;
    if (lastBooking.checkCustomer.lastName !== compareBooking.checkCustomer.lastName) return false;
    if (lastBooking.checkCustomer.phone !== compareBooking.checkCustomer.phone) return false;
    if (lastBooking.checkCustomer.phoneNational !== compareBooking.checkCustomer.phoneNational)
      return false;
    if (lastBooking.checkCustomer.email !== compareBooking.checkCustomer.email) return false;
    if (lastBooking.checkCustomer.company !== compareBooking.checkCustomer.company) return false;
    if (lastBooking.checkCustomer.lastName !== compareBooking.checkCustomer.lastName) return false;

    return true;
  }

  private isOneSec(): boolean {
    const lastBookingTime = this.getLastBookingTime();
    if (lastBookingTime) {
      const currentTime = moment().format();
      const duration = moment.duration(moment(currentTime).diff(moment(lastBookingTime)));
      const secs = duration.asSeconds();
      return secs <= 3;
    } else {
      return false;
    }
  }

  private getLastBookingTime(): string {
    return LocalStorageService.get(NgLocalStorageKey.spamBookingTime);
  }

  private getLastBooking(): any {
    return LocalStorageService.get(NgLocalStorageKey.spamBooking);
  }

  private setLastBookingTime(): void {
    LocalStorageService.set(NgLocalStorageKey.spamBookingTime, moment().format());
  }

  private setLastBooking(booking: { _id: string }): void {
    LocalStorageService.set(NgLocalStorageKey.spamBooking, booking);
  }
}

const instance = new SpamProtectionService();
export default instance as SpamProtectionService;
